import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";

import { RootState } from "Store/configureStore";

type SearchState = {
  query: string;
  isEnabled: boolean;
};

const initialState: SearchState = {
  query: "",
  isEnabled: false
};

const slice = createSlice({
  name: "search",
  initialState,
  reducers: {
    search: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
    setIsSearchEnabled: (state, action: PayloadAction<boolean>) => {
      state.isEnabled = action.payload;
    }
  }
});

export const { search, setIsSearchEnabled } = slice.actions;

export const searchSelector = (state: RootState) => state.search;

export const selectSearchQuery = createSelector(
  searchSelector,
  search => search.query || ""
);

export const selectIsSearchEnabled = createSelector(
  searchSelector,
  search => search.isEnabled
);

export default slice.reducer;
